// Transaction History Action Types
export const FETCH_CUSTOMER_TRANSACTIONS_RESOLVED = 'FETCH_CUSTOMER_TRANSACTIONS_RESOLVED';
export const FETCH_CUSTOMER_TRANSACTIONS_FAILED = 'FETCH_CUSTOMER_TRANSACTIONS_FAILED';
export const FETCH_CASHBOX_TRANSACTION_DETAILS_RESOLVED = 'FETCH_CASHBOX_TRANSACTION_DETAILS_RESOLVED';
export const FETCH_CASHBOX_TRANSACTION_DETAILS_FAILED = 'FETCH_CASHBOX_TRANSACTION_DETAILS_FAILED';
export const FETCH_IMPORT_TRANSACTION_DETAILS_RESOLVED = 'FETCH_IMPORT_TRANSACTION_DETAILS_RESOLVED';
export const FETCH_IMPORT_TRANSACTION_DETAILS_FAILED = 'FETCH_IMPORT_TRANSACTION_DETAILS_FAILED';
export const TOGGLE_TRANSACTION_EXPANDED = 'TOGGLE_TRANSACTION_EXPANDED';
export const CLEAR_TRANSACTION_HISTORY = 'CLEAR_TRANSACTION_HISTORY';
export const FETCH_CUSTOMER_TRANSACTIONS_SUMMARY_RESOLVED = 'FETCH_CUSTOMER_TRANSACTIONS_SUMMARY_RESOLVED';
